import { render, staticRenderFns } from "./WholesalerForm.vue?vue&type=template&id=1eda0224&scoped=true&"
import script from "./WholesalerForm.vue?vue&type=script&lang=js&"
export * from "./WholesalerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eda0224",
  null
  
)

export default component.exports